import {createAction} from 'redux-actions'

const PREFIX = 'FACTOR_HEALTH_BADGE'
const action = name => createAction(`${PREFIX}_${name}`)

export const init = action('INIT')
export const deinit = action('REMOVE')

export const highlightFactor = action('HIGHLIGHT_FACTOR')
export const clearHighlightedFactor = action('CLEAR_HIGHLIGHTED_FACTOR')
export const showTooltip = action('SHOW_TOOLTIP')
export const hideTooltip = action('HIDE_TOOLTIP')
